import { User } from '@angular/fire/auth';
import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '@services/app.service';

import { Observable } from 'rxjs';

const BASE_CLASSES = 'main-sidebar elevation-4';
@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
  @HostBinding('class') classes: string = BASE_CLASSES;
  public ui?: Observable<UiState>;
  public user?: User;
  public menu = MENU;

  constructor(
    public appService: AppService,
    private store: Store<AppState>
  ) {
    this.user = this.appService.user ?? undefined;
  }

  ngOnInit() {
    this.ui = this.store.select('ui');
    this.ui.subscribe((state: UiState) => {
      this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
    });

  }
}

export const MENU: {
  name: string;
  iconClasses: string;
  path?: string[];
  children?: {
    name: string;
    iconClasses: string;
    path: string[];
  }[];
}[] = [
    {
      name: 'Dashboard',
      iconClasses: 'fas fa-tachometer-alt',
      path: ['/dashboard']
    },
    {
      name: "Blog Posts",
      iconClasses: "fas fa-copy",
      children: [
        {
          name: 'Blog List',
          iconClasses: 'fas fa-list',
          path: ['/dashboard', 'blog']
        },
        {
          name: 'Add Blog',
          iconClasses: 'fas fa-plus',
          path: ['/dashboard', 'blog', 'create']
        }
      ]
    },
    // {
    //   name: "Users",
    //   iconClasses: "fas fa-user",
    //   children: [
    //     {
    //       name: 'User List',
    //       iconClasses: 'fas fa-list',
    //       path: ['/dashboard', 'user']
    //     },
    //     {
    //       name: 'Add User',
    //       iconClasses: 'fas fa-plus',
    //       path: ['/dashboard', 'user', 'create']
    //     }
    //   ]
    // },
    // house
    // {
    //   name: 'House',
    //   iconClasses: 'fas fa-home',
    //   children: [
    //     {
    //       name: 'House List',
    //       iconClasses: 'fas fa-list',
    //       path: ['/dashboard', 'house']
    //     },
    //     {
    //       name: 'Add House',
    //       iconClasses: 'fas fa-plus',
    //       path: ['/dashboard', 'house', 'create']
    //     }
    //   ]
    // },
    // pages
    // {
    //   name: 'Pages',
    //   iconClasses: 'fas fa-file',
    //   children: [
    //     {
    //       name: 'Page List ',
    //       iconClasses: 'fas fa-square',
    //       path: ['/dashboard', 'page']
    //     },
    //     {
    //       name: 'Add Page',
    //       iconClasses: 'fas fa-plus',
    //       path: ['/dashboard', 'page', 'create']
    //     }
    //   ]
    // },
    // Team
    {
      name: 'Portfoilo',
      iconClasses: 'fa-solid fa-cubes',
      children: [
        {
          name: 'Project List',
          iconClasses: 'fa-solid fa-cube',
          path: ['/dashboard', 'portfoilo']
        },
        {
          name: 'Add New Project',
          iconClasses: 'fas fa-plus',
          path: ['/dashboard', 'portfoilo', 'create']
        }
      ]
    }

  ];
